import React, { useRef } from 'react';
import Clarity from '@microsoft/clarity';
import envConfig from '../../config';

// Materials UI
import { Typography, Box, Container } from '@mui/material';

//Menu List
import { Navbar, DrawerHeader } from '@arredo/reactjs-ui';
import Routes from '../../router/routes';

// Hooks
import useUser from '../../hooks/user/useUser';

// Components
import BranchesModal from './branchesModal';
import UserMenuNavbar from './userMenu/UserMenuNavbar';

const Layout = ({ children }) => {
    const projectId = envConfig.clarityProjectId;
    const rootRef = useRef(null);
    const { email, branch } = useUser();

    if (projectId?.length > 0) {
        Clarity.init(projectId);
    }

    return (
        <>
            <Box display='flex' ref={rootRef} overflow='unset'>
                <Navbar
                    title='POS'
                    menu={<Routes />}
                    navMenu={<UserMenuNavbar />}
                />
                <Box component='main' height='100vh' overflow='auto' sx={{ flexGrow: 1, py: 3 }}>
                    <DrawerHeader />
                    <Container maxWidth='xxl'>
                        {children}
                        <Box component='footer' marginTop={4}>
                            <Typography variant='subtitle1' align='center'>
                                &copy; 2020 - Arredo
                            </Typography>
                        </Box>
                    </Container>
                </Box>
                {
                    Boolean(email && !branch?.id) &&
                    <BranchesModal rootRef={rootRef} />
                }

            </Box>
        </>
    )
}

export default Layout;